import type { CSS } from '@grupoboticario/flora-react'

export const modalWrapperCss: CSS = {
  width: '100%'
}

export const modalBodyCss: CSS = {
  minHeight: '300px',
  whiteSpace: 'pre-wrap'
}
